module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAfCAMAAAAlbpZMAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURa7K/yZi/zBl/zJl/zJl/zJl/zJl/0dwTDJm/zJl/1GA/zJl/zJl/67J/zFl/63J/67J/6/I/zJk/y1i/zJk/63J/6zI/zNm/67J/wZ+zCQAAAAXdFJOU78FQu/O3ZEAf58RvrX3U0e5YS4fa84ubEBdTgAAAJ5JREFUKM+l0N0OgyAMBeCCFcaPgrqtvP+TTuZMQOoFWS8IOV8CJwVdjvTDet6hzJGIHo2Ib96KmI/8KmIeiRgp80qsI2LFjnSVZQpZFDUCaXrvJ3KSJquBWEkvcSdp+Ql674dK4BCVa9o+odE5x77GNDjFKKXw9h/Bicmy8Q326WwwzFJK09fAZVn5BojYu4O/JR7yNNWoTesQAWL4AMvQL8LKMEiMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MallPage/engineering.png
// module id = wYPu
// module chunks = 0